<template>
  <span
    :class="[labelVariants({ variant, size })]"
  >
    <slot />
  </span>
</template>

<script>
import { cva } from 'class-variance-authority';

const labelVariants = cva(
  'text-xs font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  {
    variants: {
      variant: {
        primary: 'text-blue-800 bg-blue-100',
        purple: 'text-purple-800 bg-purple-100',
        yellow: 'text-yellow-800 bg-yellow-100',
        orange: 'text-orange-800 bg-orange-100',
        green: 'text-green-800 bg-green-100',
        red: 'text-yellow-500 bg-yellow-50',
        gray: 'text-gray-900 bg-gray-200'
      },
      size: {
        default: 'text-s-medium rounded-md py-1 px-2',
        small: 'text-2xs-medium py-[3px] rounded-2xs py-[2px] px-1'
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default'
    }
  }
)

export default {
  name: 'Label',
  props: {
    value: String,
    variant: String,
    size: String
  },
  methods: {
    labelVariants
  }
}
</script>
